import { useState, useEffect } from "react";
import { DataGrid, GridActionsCellItem, GridToolbar } from "@mui/x-data-grid";
import { Box, Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, InputLabel, MenuItem, Select, Typography } from "@mui/material";
import { APPOINTMENT_BACKEND_URL } from "../assets/staticData";
import { Link } from "react-router-dom";
import useModal from "../hooks/use-modal";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import { Tooltip, IconButton } from '@mui/material';
import { TextField, Autocomplete } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

const Appointment = ({ user }) => {

  const [appointments, setAppointments] = useState([]);
  const [pagination, setPagination] = useState(null);
  const [loading, setLoading] = useState(false)
  const [selectedAppointment, setSelectedAppointment] = useState(null)

  const changeStatusModal = useModal()
  const viewModal = useModal();
  const editModal = useModal();

  async function fetchAppointments(page = 1, pageSize = 10) {
    try {
      setLoading(true)

      let userToken = localStorage.getItem("userToken");
      const headers = {
        authorization: `Bearer ${userToken}`,
      };

      const res = await fetch(`${APPOINTMENT_BACKEND_URL}/appointment/report?page=${page}&pageSize=${pageSize}`, {
        headers,
        method: "GET",
      })

      const response = await res.json();

      setAppointments(response.data.data)
      setPagination(response.data.pagination)
      setLoading(false)

    } catch (error) {
      console.log(error)
      setLoading(false)

    }
  }

  useEffect(() => {
    fetchAppointments()
  }, [])


  const columns = [
    {
      field: "customerFullName",
      headerName: "User",
      width: 160,
    },
    {
      field: "phone",
      headerName: "Phone",
      width: 170,
      renderCell: (params) => {

        const { row } = params

        return <span>({row.customerPhoneCode}) {row.customerPhone}</span>
      }
    },
    {
      field: "customerEmail",
      headerName: "Email",
      width: 200,
    },
    {
      field: "type",
      headerName: "Type",
      width: 160,
      renderCell: (params) => {

        const { row: { type } } = params

        const color = type === "INVEST"
          ? "success"
          : (type === "CLEARING" ? "primary" : "warning")

        return <Chip label={type} color={color} style={{ fontWeight: 500 }} />

      }
    },
    {
      field: "status",
      headerName: "Status",
      width: 160,
      renderCell: (params) => {

        const { row: { status } } = params

        const color = status === "COMPLETED"
          ? "success"
          : (status === "CANCELLED" ? "error" : "primary")

        return <Chip label={status} color={color} style={{ fontWeight: 500 }} />

      }
    },
    {
      field: "startAt",
      headerName: "Meeting Date",
      width: 200,
      renderCell: (params) => {

        const { row } = params
        if (!row.startAt) return "-"

        const startDate = new Date(row.startAt)
        return <span style={{ fontWeight: 500 }}>{startDate.toLocaleDateString()}-{startDate.toLocaleTimeString()}</span>
      }
    },
    {
      field: "meetingLink",
      headerName: "Link",
      width: 100,
      renderCell: (params) => {
        const { row: { meetingLink } } = params

        if (!meetingLink) return "-"

        return <Link
          to={meetingLink}
          target="_blank"
          style={{
            color: "#00166a",
            fontWeight: 500
          }}>Meet Link</Link>
      }
    },
    {
      field: "createdAt",
      headerName: "Created At",
      width: 200,
      renderCell: (params) => {

        const { row } = params
        if (!row.startAt) return "-"

        const startDate = new Date(row.startAt)
        return <span>{startDate.toLocaleDateString()}-{startDate.toLocaleTimeString()}</span>
      }
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 150,
      getActions: (params) => [
        // <Switch
        //   size="small"
        //   checked={params.row.public}
        //   disabled={!user.perms[permNumber].edit}
        //   onChange={() => {/* Add your toggle logic here */ }}
        // />,
        // <GridActionsCellItem
        //   icon={<EditIcon />}
        //   label="Edit"
        //   // disabled={!user.perms[permNumber].edit}
        //   onClick={() => onAppointmentChangeStatusModal(params.row)}
        // />,
        <GridActionsCellItem
          icon={<EditIcon color="action" />}
          label="Edit"
          onClick={() => {
            setSelectedAppointment(params.row);
            editModal.open();
          }}
        />,
        <Tooltip title="Update Status">
          <IconButton onClick={() => onAppointmentChangeStatusModal(params.row)}>
            <PublishedWithChangesIcon sx={{ color: '#00166a' }} />
          </IconButton>
        </Tooltip>,
        <GridActionsCellItem
          icon={<VisibilityIcon color="primary" />}
          label="View"
          onClick={() => onAppointmentViewModal(params.row)}
        />,
        // <GridActionsCellItem
        //   icon={<GridDeleteIcon />}
        //   label="Delete"
        //   disabled={!user.perms[permNumber].delete}
        //   onClick={() => console.log("Delete ID:", params.id)}
        // />,
      ],
    },
  ];

  const onChangeQuery = async ({ page, pageSize }) => {
    fetchAppointments(page + 1, pageSize);
  }

  const onAppointmentChangeStatusModal = (appointment) => {
    setSelectedAppointment(appointment)
    changeStatusModal.open()
  }

  const onCloseChangeStatusModal = () => {
    changeStatusModal.close()
    viewModal.close()
    editModal.close()
    setSelectedAppointment(null)

    fetchAppointments(pagination?.currentPage, pagination?.pageSize)
  }

  const onSubmitChangeStatusModal = () => {
    onCloseChangeStatusModal(null)
  }

  const onAppointmentViewModal = (appointment) => {
    setSelectedAppointment(appointment);
    viewModal.open();
  };

  return (
    <section>
      <Box sx={{ width: "100%" }}>
        <h3>
          Appointments
        </h3>
      </Box>

      <Box mt={2}>
        <DataGrid
          rows={appointments}
          columns={columns}
          loading={loading}
          paginationMode="server"
          rowCount={pagination?.totalItems || 0}
          pageSizeOptions={[10, 25, 50]}
          paginationModel={{
            page: Math.max(0, (pagination?.currentPage || 1) - 1),
            pageSize: pagination?.pageSize || 10,
          }}
          onPaginationModelChange={onChangeQuery}
          slots={{ toolbar: GridToolbar }}
          slotProps={{
            toolbar: {
              showQuickFilter: false,
              csvOptions: { disableToolbarButton: true },
              printOptions: { disableToolbarButton: true },
            },
          }}
          getRowId={(d) => d.uuid}
          disableRowSelectionOnClick
        />
      </Box>

      <ChangeStatusModal
        isOpen={changeStatusModal.isVisible && !!selectedAppointment}
        appointment={selectedAppointment}
        onClose={onCloseChangeStatusModal}
        onSubmit={onSubmitChangeStatusModal} />

      <ViewAppointmentModal
        isOpen={viewModal.isVisible && !!selectedAppointment}
        appointment={selectedAppointment}
        onClose={onCloseChangeStatusModal} />

      <EditAppointmentModal
        isOpen={editModal.isVisible && !!selectedAppointment}
        appointment={selectedAppointment}
        onClose={onCloseChangeStatusModal}
        onRefresh={() => fetchAppointments(pagination?.currentPage, pagination?.pageSize)}
      />
    </section>
  )
}

export default Appointment

const ChangeStatusModal = ({ isOpen, onClose, appointment }) => {
  const { control, handleSubmit, reset } = useForm({
    defaultValues: {
      newStatus: ""
    }
  });

  const onSubmit = async (data) => {
    try {

      let userToken = localStorage.getItem("userToken");
      const headers = {
        "Content-Type": "application/json",
        authorization: `Bearer ${userToken}`,
      };

      const res = await fetch(`${APPOINTMENT_BACKEND_URL}/appointment/change-status/${appointment.uuid}`, {
        headers,
        method: "PATCH",
        body: JSON.stringify(data)
      })

      if (res.ok) {
        reset();
        onClose()

        toast("Appointment status changed", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          type: "success",
        });
      }

    } catch (error) {
      toast("Can not change appointment status, Please try again", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        type: "error",
      });
    }

  };

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth={false}
      PaperProps={{
        style: { width: 'fit-content', minWidth: 320 },
      }}
    >
      <DialogTitle>Change Status</DialogTitle>

      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogContent dividers>
          <FormControl
            sx={{
              minWidth: 300,
              width: "100%",
              mt: 1,
            }}
            size="small"
          >
            <InputLabel id="status-select-label">Status</InputLabel>

            <Controller
              name="newStatus"
              control={control}
              rules={{ required: "Status is required" }}
              render={({ field, fieldState: { error } }) => (
                <>
                  <Select
                    {...field}
                    labelId="status-select-label"
                    id="status-select"
                    label="Status"
                    error={!!error}
                  >
                    {[
                      { label: "Pending", value: "PENDING" },
                      { label: "Completed", value: "COMPLETED" },
                      { label: "Cancelled", value: "CANCELLED" },
                    ].map((status) => (
                      <MenuItem key={status.value} value={status.value}>
                        {status.label}
                      </MenuItem>
                    ))}
                  </Select>

                  {error && <span style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>{error.message}</span>}
                </>
              )}
            />
          </FormControl>
        </DialogContent>

        <DialogActions>
          <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', pb: 2 }}>

            <button
              type="submit"
              className="submitBTN"
              style={{ cursor: 'pointer', border: 'none' }}
            >
              Save Changes
            </button>
          </Box>
        </DialogActions>
      </form>
    </Dialog>
  );
};

const ViewAppointmentModal = ({ isOpen, onClose, appointment }) => {
  if (!appointment) return null;

  const DetailRow = ({ label, value }) => (
    <Box sx={{ mb: 1.5 }}>
      <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 'bold', display: 'block' }}>
        {label}
      </Typography>
      <Typography variant="body1">
        {value || "-"}
      </Typography>
    </Box>
  );

  const renderDetail = () => {
    const { meta, type } = appointment;
    if (!meta) return null;

    switch (type) {
      case "CLEARING": // Based on AppointmentType.CLEARING
        return (
          <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
            <DetailRow label="Business Type" value={meta.businessType} />
            <DetailRow label="Trading Volume" value={meta.tradingVolume} />
            <DetailRow label="Markets" value={meta.markets} />
            <DetailRow label="Requirements" value={meta.requirements} />
          </Box>
        );

      case "INVEST": // Based on AppointmentType.INVEST
        return (
          <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
            <DetailRow label="Asset Classes" value={meta.investmentAssetClasses} />
            <DetailRow label="Preferences" value={meta.investmentPreferences} />
            <DetailRow label="Time Horizon" value={meta.investmentTimeHorizon} />
            <DetailRow label="Requirements" value={meta.requirements} />
          </Box>
        );

      case "PARTNERSHIP": // Based on AppointmentType.PARTNERSHIP
        return (
          <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
            <DetailRow label="Company" value={meta.company} />
            <DetailRow label="Corporate Config" value={meta.desiredCorporateConfiguration} />
            <DetailRow label="Software Infra" value={meta.desiredSoftwareInfrastructure} />
            <DetailRow label="Requirements" value={meta.requirements} />
          </Box>
        );

      default:
        return <DetailRow label="Requirements" value={meta.requirements} />;
    }
  };
  return (
    <Dialog open={isOpen} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ fontWeight: 'bold' }}>Appointment Details</DialogTitle>
      <DialogContent dividers>
        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
          <DetailRow label="Full Name" value={appointment.customerFullName} />
          <DetailRow label="Email" value={appointment.customerEmail} />
          <DetailRow label="Phone" value={`(${appointment.customerPhoneCode}) ${appointment.customerPhone}`} />
          <DetailRow label="Type" value={<Chip label={appointment.type} size="small" />} />
          <DetailRow label="Status" value={<Chip label={appointment.status} size="small" color="primary" variant="outlined" />} />
          <DetailRow
            label="Meeting Date"
            value={appointment.startAt ? new Date(appointment.startAt).toLocaleString() : "-"}
          />
        </Box>

        <Divider sx={{ my: 2 }}>
          <Typography variant="overline" color="text.disabled">Specific Details</Typography>
        </Divider>

        {/* Dynamic Meta Info */}
        <Box>
          {renderDetail()}
        </Box>

        <Divider sx={{ my: 2 }} />

        <DetailRow
          label="Meeting Link"
          value={appointment.meetingLink ? (
            <Link to={appointment.meetingLink} target="_blank" style={{ color: "#00166a" }}>
              Join Meeting
            </Link>
          ) : "No link available"}
        />
      </DialogContent>
      <DialogActions>
        <button className="submitBTN" onClick={onClose} style={{ border: 'none', cursor: 'pointer' }}>
          Close
        </button>
      </DialogActions>
    </Dialog>
  );
};

const EditAppointmentModal = ({ isOpen, onClose, appointment, onRefresh }) => {
  const { control, handleSubmit, reset, watch } = useForm();

  const formatToLocalDatetime = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const offset = date.getTimezoneOffset() * 60000;
    const localISOTime = new Date(date.getTime() - offset).toISOString().slice(0, 16);
    return localISOTime;
  };

  useEffect(() => {
    if (appointment) {
      reset({
        startAt: formatToLocalDatetime(appointment.startAt),
        attendees: appointment.attendees || [],
        notes: appointment.notes
      });
    }
  }, [appointment, reset]);

  const onSubmit = async (data) => {
    try {
      let userToken = localStorage.getItem("userToken");
      const res = await fetch(`${APPOINTMENT_BACKEND_URL}/appointment/${appointment.uuid}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${userToken}`,
        },
        body: JSON.stringify({
          ...data,
          startAt: new Date(data.startAt).toISOString()
        }),
      });

      if (res.ok) {
        toast.success("Appointment updated successfully");
        onRefresh();
        onClose();
      } else {
        // Parse the error body from the server (e.g., 400 Bad Request, 401 Unauthorized)
        const errorData = await res.json();

        if (errorData.messages) {
          for (const message of errorData.messages) {
            toast.error(message || "Failed to update appointment");
          }
        }
      }
    } catch (error) {
      toast.error("Failed to update appointment");
    }
  };

  if (!appointment) return null;

  return (
    <Dialog open={isOpen} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle sx={{ fontWeight: 'bold' }}>Edit Appointment</DialogTitle>
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogContent dividers>
          <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 3 }}>

            {/* 1. Start Date Editing */}
            <Controller
              name="startAt"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Meeting Date & Time"
                  type="datetime-local"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />
              )}
            />

            <Controller
              name="attendees"
              control={control}
              render={({ field }) => (
                <Autocomplete
                  multiple
                  freeSolo
                  options={[]}
                  value={field.value || []}
                  onChange={(_, newValue) => field.onChange(newValue)}
                  renderInput={(params) => (
                    <TextField {...params} label="Attendees List (Press Enter)" placeholder="Add emails" />
                  )}
                />
              )}
            />
          </Box>

          <Divider sx={{ my: 3 }} />

          {/* 3. Dynamic Meta Fields based on Type */}
          <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
            <Box sx={{ gridColumn: '1 / span 2' }}>
              <Controller name="notes" control={control} render={({ field }) => <TextField {...field} label="Note" multiline rows={3} fullWidth />} />
            </Box>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <button type="submit" className="submitBTN" style={{ border: 'none', cursor: 'pointer' }}>
            Update Appointment
          </button>
        </DialogActions>
      </form>
    </Dialog>
  );
};